import type { WeekDayAvailability } from "@/pages/human-resources/time-management/business/contract/WeekDayAvailability.ts";
import { DateTime } from "luxon";
import type { EmployeeContracts } from "@/pages/human-resources/time-management/business/contract/EmployeeContracts.ts";
import type { Contract } from "@/pages/human-resources/time-management/business/contract/Contract.ts";

export class Employee {
  public constructor(
    public readonly id: string,
    public readonly code: string | undefined,
    public readonly lastName: string,
    public readonly firstName: string,
    public readonly dateOfBirth: Date,
    public readonly email: string | undefined,
    public readonly weeklyAvailability: WeekDayAvailability[],
    public readonly contracts: EmployeeContracts,
  ) {}

  public computeAgeAtDate(date: Date): number {
    const diff = DateTime.fromJSDate(date).diff(
      DateTime.fromJSDate(this.dateOfBirth),
      "years",
    );
    return Math.floor(diff.years);
  }

  public mainSiteFirstContract(): Contract {
    return this.contracts.onMainSite[0];
  }

  public mainSiteContractAtDate(date: Date): Contract | undefined {
    return this.contracts.onMainSite.find((c) => c.isEffectiveAtDate(date));
  }

  public mainSiteContracts(): Contract[] {
    return this.contracts.onMainSite;
  }
}
